var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconmonstrPayment4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6c.276 0 .5.224.5.5v11c0 .276-.224.5-.5.5h-19c-.276 0-.5-.224-.5-.5v-11c0-.276.224-.5.5-.5h19zm2.5 0c0-1.104-.896-2-2-2h-20c-1.105 0-2 .896-2 2v12c0 1.104.895 2 2 2h20c1.104 0 2-.896 2-2v-12zm-13.553 3.63h1.295l-.81 4.753h-1.295l.81-4.753zm3.907 1.908c-.453-.22-.73-.367-.727-.589 0-.198.235-.409.742-.409.424-.007.73.086.97.182l.116.055.176-1.03c-.257-.096-.659-.2-1.161-.2-1.28 0-2.182.645-2.189 1.568-.007.683.644 1.064 1.135 1.291.504.233.674.381.671.59-.003.318-.403.464-.775.464-.518 0-.794-.072-1.219-.249l-.167-.076-.182 1.064c.303.133.862.248 1.443.254 1.362 0 2.246-.637 2.256-1.624.003-.541-.342-.952-1.089-1.291zm5.646 2.846h-1.202l-.158-.712-1.659-.002-.273.714h-1.36l1.924-4.355c.136-.309.368-.394.678-.394h1.001l1.049 4.749zm-1.571-1.686l-.3-1.372-.088-.41-.172.454-.516 1.328h1.076zm-9.879-3.065l-1.268 3.241-.135-.659-.454-2.184c-.079-.3-.306-.39-.588-.401h-2.089l-.016.099c.508.123.962.3 1.361.521l1.152 4.128 1.371-.002 2.039-4.743h-1.373z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconmonstrPayment4);
export default __webpack_public_path__ + "static/media/iconmonstr-payment-4.14bf7499209a9b8750c46842759ea4f4.svg";
export { ForwardRef as ReactComponent };